/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { BEBOP_ROUTES } from "config/consts";
import React, { useMemo } from "react";
import ReactModal from "react-modal";
import { useLocation } from "react-router-dom";
import { WrapStatus } from "types/wrapQuote";
import confirm_img from "../../../../img/trade-interface/confirm_trade.png";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Amount } from "../../../../types/amount";
import { OrderStatus } from "../../../../types/orderStatus";
import { TradeDetailsSection } from "../../../DetailsSection/TradeDetailsSection";
import { ProgressBar } from "../../../ProgressBar/ProgressBar";
import { ModalContent } from "../../../general/ModalContent/ModalContent";
import { Spacer } from "../../../general/Spacer/Spacer";
import { ModalHeader } from "../../elements/ModalHeader";
import { MODAL_SELECTORS } from "../modalSelectors";
import { YouPaySection } from "./YouPaySection";
import { YouReceiveSection } from "./YouReceiveSection";

export const ConfirmTradeModal: React.FC = () => {
  const modalSelector = GlobalStore.useState(s => s.modalSelector);
  const theme = GlobalStore.useState(s => s.theme);
  const isWrapPage = useLocation().pathname === BEBOP_ROUTES.Wrap;
  const isTradePage = useLocation().pathname === BEBOP_ROUTES.Trade;
  const isWrapFlow = GlobalStore.useState(s => s.wrapStatus) !== WrapStatus.ENTRY;
  const wrapQuote = GlobalStore.useState(s => s.wrapQuote);
  const description = useMemo(() => {
    if (isWrapPage || (isTradePage && wrapQuote != null))
      return "Please allow this transaction by clicking Confirm.";
    return "Please confirm this trade in your wallet by scrolling to the bottom of the message and clicking Sign.";
  }, [isTradePage, isWrapPage, wrapQuote]);
  const { networkFee } = GlobalStore.useState(s => {
    return { networkFee: s.quote?.usdGasFee };
  });
  const handleClose = () => {
    GlobalStore.update(s => {
      s.modalSelector = undefined;
      s.signedMessage = undefined;
      s.orderStatus = OrderStatus.REVIEW;
    });
  };

  return (
    <ReactModal
      isOpen={modalSelector === MODAL_SELECTORS.CONFIRM_TRADE}
      className={`react-modal new-skin modal-dialog modal-dialog-centered m-frame`}
      style={{
        content: {
          margin: "0 auto",
          marginTop: 80,
        },
      }}
      shouldCloseOnOverlayClick={false}
      onRequestClose={handleClose}
    >
      <ModalContent style={{ padding: "15px" }} backgroundColor="alt">
        <div className={`modal-body`} style={{ paddingTop: 0 }}>
          <ModalHeader theme={theme}>Confirm Trade</ModalHeader>
          <div className="sp12"></div>
          <div className="text-center">
            <img alt={"Confirm trade"} src={confirm_img} width={110} height={103} />
          </div>
          <div className="sp28"></div>

          <p
            className="text-center modal-text"
            css={css`
              font-family: ${theme.fontFamilies["work-sans"]};
              font-size: ${theme.fontSize["5"]};
            `}
          >
            {description}
          </p>
        </div>
        <div className={"review-trade-section"}>
          {/* hide if trade is a wrap action */}
          {isTradePage && !isWrapFlow && (
            <>
              <YouPaySection shouldDisplayLabel={true} />
              <div className="sp10"></div>
              <YouReceiveSection shouldDisplayLabel={true} />
              <Spacer height="22px" />
              <TradeDetailsSection networkFee={networkFee ?? Amount.ZERO} visible={true} />
            </>
          )}
          <Spacer height="10px" />
          <div className={"progress-bar-container"}>
            <ProgressBar step={3} />
          </div>
        </div>
      </ModalContent>
    </ReactModal>
  );
};
